import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent } from '@app/shared/dialog/confirm-dialog/confirm-dialog.component';
import { LoadingDialogComponent } from '@app/shared/dialog/loading-dialog/loading-dialog.component';
import { FormDialogComponent } from '@app/shared/dialog/form-dialog/form-dialog.component';
import { FormBase } from '@app/shared/models/form-base.model';
import { PicklistEditorDialogComponent } from '@app/shared/dialog/picklist-editor-dialog/picklist-editor-dialog.component';

@Injectable()
export class DialogService {
    private dialog = inject(MatDialog);

    private showingLoader = false;
    private loaderId;

    public open(
        title: string,
        content: string,
        showCancelButton = true,
        config: MatDialogConfig = {
            disableClose: false,
            autoFocus: true,
            hasBackdrop: true
        }): Observable<boolean> {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, config);

        dialogRef.componentInstance.dialog = {
            title: title,
            content: content,
            showCancelButton: showCancelButton
        };

        return dialogRef.afterClosed();
    }

    public openFormDialog(title: string,
        content: string,
        fields: FormBase<any>[],
        showCancelButton = true,
        showAddButton = false,
        config: MatDialogConfig = {
            disableClose: false,
            autoFocus: true,
            hasBackdrop: true
        }): Observable<{ ok: boolean, data: any }> {

        const dialogRef = this.dialog.open(FormDialogComponent, config);
        dialogRef.componentInstance.dialog = {
            title: title,
            content: content,
            showCancelButton: showCancelButton,
            showAddButton: showAddButton,
            fields: fields
        };
        return dialogRef.afterClosed();
    }

    public openPicklistDialog(title: string,
        content: string,
        fields: FormBase<any>[],
        showCancelButton = true,
        showAddButton = false,
        config: MatDialogConfig = {
            disableClose: false,
            autoFocus: true,
            hasBackdrop: true
        }): Observable<{ ok: boolean, data: any }> {

        const dialogRef = this.dialog.open(PicklistEditorDialogComponent, config);
        dialogRef.componentInstance.dialog = {
            title: title,
            content: content,
            showCancelButton: showCancelButton,
            showAddButton: showAddButton,
            fields: fields
        };
        return dialogRef.afterClosed();
    }

    public async showLoader(): Promise<void> {
        if (this.showingLoader) {
            return;
        }

        this.showingLoader = true;

        const config: MatDialogConfig = {
            disableClose: true,
            panelClass: 'inspekt-loading-dialog',
            closeOnNavigation: true
        };

        const dialogRef = this.dialog.open(LoadingDialogComponent, config);
        this.loaderId = dialogRef.id;

        return await dialogRef.afterOpened().toPromise();
    }

    public async hideLoader(): Promise<void> {
        if (this.loaderId == null || !this.showingLoader) {
            return;
        }

        const dialogRef = this.dialog.getDialogById(this.loaderId);
        dialogRef.close();
        this.showingLoader = false;

        return await dialogRef.afterClosed().toPromise();
    };
}
